import { formatDate } from "../utils/format";

let sq = {
  translations: {
    personal: "Individ",
    business: "Biznes",
    partners: "Partnerët Ndërkombëtare",
    searchbar: {
      input: "Kërko...",
      close: "Mbylle",
      search: "Kërko",
    },
    pages: {
      career: {
        label: "Karriera",
      },
      propertiesForSale: {
        label: "Prona në shitje",
      },
      home: {
        selections: "Zgjedhjet tona",
        digitalPlatforms: {
          title: "Platforma digjitale",

          description:
            "Shkolla e Magjistraturës ofron disa platforma per formimin fillestar të kandidatëve për magjistratë dhe formimin vazhdues të gjyqtarëve dhe prokurorëve.",

          eLearning: {
            description: "Hyr ",
          },
          eCommentary: {
            description: "Hyr ",
          },
          eLibrary: {
            description: "Hyr ",
          },
        },
      },
      contact: {
        label: "Kontakt",
        phoneNumberDescription: "Për telefonata hyrëse jashtë bankës",
        tollFreeDescription: "Në dispozicionin tuaj, numër pa pagesë",
        emailDescription:
          "Kontaktoni nëpërmjet postës elektronike ose plotesoni një",
        form: "formular",
      },
      branches: {
        label: "Degët dhe ATM-të",
      },
      about: {
        label: "Rreth nesh",
        description:
          "14 vjet zhvillim të qëndrueshëm me fokus në invacionin dhe shërbimin ndaj klientit",
      },
      news: {
        label: "Njoftime",
        latestNews: "Lajmi i fundit",
        allNews: "Të gjitha lajmet",
        types: {
          PUBLICATION: "Publikim",
          ACTIVITY: "Aktivitet",
          NEWS: "Njoftim",
          RECRUITMENT: "Rekrutim",
          plural: {
            PUBLICATION: "Publikime",
            ACTIVITY: "Aktivitete",
            NEWS: "Njoftime",
            RECRUITMENT: "Rekrutime"
          },
        },
      },
      help: {
        label: "Ndihmë",
      },
      personalData: {
        label: "Të dhënat personale",
      },
      cookiesManagement: {
        label: "Menaxhimi",
      },
      legalInformation: {
        label: "Ingormacion ligjor",
      },
      search: {
        search: "Kërko",
        loading: "Duke u ngarkuar...",
        results: "rezultate",
        noResults: "Nuk u gjetën rezultate",
        searchParam: "Parametri i kërkimit",
      },
      clientServices: {
        yourDetails: "Detajet tuaja",
        title: "Fibank në shërbimin tuaj",
        name: "Emri",
        lastname: "Mbiemri",
        phoneNumber: "Numri i telefonit",
        email: "Email",
        fibankClient: "Jeni klient i Fibank?",
        fibankClientOptions: {
          yes: "Po",
          no: "Jo",
        },
        city: "Qyteti",
        type: "Tipi i kërkesës",
        typeOptions: {
          individualOpportunity: "Mundësi financimi individë",
          businessOpportunity: "Mundësi financimi biznese",
          creditCard: "Kartë debiti/krediti",
          myPension: "Pensioni im",
          other: "Tjetër",
        },
        description: "Përshkrimi",
      },
      mortgageApplication: {
        step1: {
          stepTitle: "Hapi",
          title: "Llogaritësi i kredisë",
          subtitle:
            "Mund të përdorni llogaritësin e kredisë për të parë vlerat e pagesave tuaja mujore.",
          currencyType: "Lloji i monedhës:",
          mortgageType: "Tipi i kredisë:",
          mortgageSum: "Shuma e kredisë:",
          chooseMortgage: "Zgjidhni tipin e kredisë",
          mortgagePeriods: "Afati i kredisë (Muaj):",
          calculate: "Llogarit",
          interesRate: "Norma e interesit",
          monthlyPayments: "Pagesa mujore",
          totalPayments: "Totali për tu paguar",
          continue: "Vazhdo më tej",
        },
        step2: {
          stepTitle: "Hapi",
          title: "Detajet e kredisë",
          mortgageDetails: {
            title: "Të dhëna shtesë mbi kredinë",
            mortgageType: "Tipi i kredisë",
            mortgageTypeOptions: {
              consumerCredit: "Kredi konsumatore",
              mortgageLoan: "Kredi hipotekore",
              ovd: "OVD",
              ovdWithSecurity: "Kredi/OVD me letra me vlerë",
              ovdWithCashCollateral: "Kredi/OVD me cash kolateral",
            },
            usedFor: "Përdorur për:",
            warrantorNumber: "Numri i garantorëve:",
          },
          employmentDetails: {
            title: "Të dhënat e punësimit",
            employmentStatus: "Statusi i punësimit:",
            employmentStatusOptions: {
              unemployed: "I papunësuar",
              selfEmployed: "I vetëpunësuar",
              student: "Student",
              retiree: "Pensionist",
              partTime: "I punësuar me kohë të pjesshme",
              fullTime: "I punësuar me kohë të plotë",
            },
            netIncome: "Të ardhurat neto:",
            netIncomeCurrency: "Monedha:",
            otherMortgagePayments: "Pagesa mujore e kredive që keni:",
            otherMortgagePaymentsCurrency: "Monedha:",
          },
          clientDetails: {
            title: "Detajet e klientit",
            firstname: "Emri:",
            lastname: "Mbiemri:",
            gender: "Gjinia:",
            birthdate: "Data e lindjes (Muaji/Dita/Viti):",
            clientType: "Tipi i klientit:",
            clientTypeOptions: {
              individual: "Individ",
              business: "Biznes",
            },
            email: "Adresa e Email-it:",
            city: "Qyteti:",
            phoneNumber: "Numri i telefonit:",
          },
          otherDetails: {
            salaryInfo: "Ku e merrni pagën:",
            salaryInfoOptions: {
              cash: "Cash",
              bank: "Bankë",
            },
            knownThrough: "Si jeni njoftuar për produktet tona?",
            knownThroughOptions: {
              tv: "TV",
              radio: "Radio",
              socialMedia: "Media Sociale Facebook/Instagram/Google",
              relative: "I afërm",
              staff: "Stafi i Fibank",
              website: "Website",
              leaflet: "Fletëpalosje",
              other: "Tjetër",
            },
          },
          sendInfo: "Dërgo të dhënat",
        },
      },
      creditCardApplication: {
        step1: {
          stepTitle: "Hapi",
          title: "Parametrat",
          subtitle:
            "Specifiko monedhën dhe limitin e dëshiruar, dhe më pas bëni përzgjedhjen e kartës.",
          currencyType: "Lloji i monedhës:",
          cardLimit: "Limiti i kartës:",
          goOn: "Shiko kartat",
          continue: "Vazhdo më tej",
        },
        step2: {
          stepTitle: "Hapi",
          title: "Detajet e kërkesës",
          clientDetails: {
            title: "Detajet e klientit",
            firstname: "Emri:",
            lastname: "Mbiemri:",
            gender: "Gjinia:",
            birthdate: "Data e lindjes (Muaji/Dita/Viti):",
            email: "Adresa e Email-it:",
            city: "Qyteti:",
            phoneNumber: "Numri i telefonit:",
          },
        },
      },
      depositCalculator: {
        title: "Llogaritësi i depozitës",
        currency: "Monedha",
        months: "Muajt",
        kind: "Lloji i depozitës",
        sum: "Shuma",
        calculate: "Llogarit",
        interest: "Interesi",
        total: "Shuma totale",
        choose: "Zgjidh",
      },
      properties: {
        APARTMENT: "Apartament",
        VILLA: "Vilë",
        RESIDENTIAL_LAND: "Truall",
        BUILDING: "Ndërtesë",
        AGRICULTURAL_LAND: "Tokë bujqësore",
        GARAGE: "Garazh",
        SALE: "Shitje",
        RENT: "Qera",
        choose: "Zgjidhni",
        transactionType: "Shitje ose qera",
        propertyType: "Tipi i objektit",
        price: "Çmimi",
        city: "Qyteti",
        noResults: "Nuk e gjetën rezultate me filtrat e kërkuar",
        properties: "Prona",
        filterParameters: "Parametrat e filtrimit",
        all: "Të gjitha",
        cityType: "Zgjidhni qytetin:",
      },
    },
    notFoundPage: {
      status: 404,
      errorDescription: "Faqja e kërkuar nuk u gjend!",
      errorMessage: "🏠 Faqja kryesore",
      suggestion: "Kthehuni në faqen kryesore.",
    },
    needs: {
      title: "Kërkoj:",
      button: {
        text: "Sygjerimet tona",
      },
      items: {
        account: {
          text: "Llogari",
        },
        home: {
          text: "Kredi Hipotekore",
        },
        savings: {
          text: "Depozita dhe Investime",
        },
        credit: {
          text: "Overdraft",
        },
        travel: {
          text: "Udhëtime",
        },
        furniture: {
          text: "Kredi për çdo qëllim",
        },
        card: {
          text: "Kartë bankare",
        },
        insurance: {
          text: "Fibank Mobile",
        },
      },
    },
    plainCard: {
      buttonText: {
        text: "Lexo më tepër",
      },
    },
    contactPage: {
      header: {
        title: "Kontakt",
      },
    },
    branchesPage: {
      hideText: "Fshih",
      noResults: "Nuk u gjetën rezultate",
      title: "Degët dhe ATM",
      filterByText: "Filtro sipas:",
      allCitiesText: "Të gjitha qytetet",
      selectTypeText: "Zgjidhni një tip",
    },
    exchange: {
      title: "Kursi i këmbimit",
      seeAllRates: "Shiko të gjitha monedhat",
      buy: "Blihet",
      sell: "Shitet",
      unit: "Njësia",
      notes: "Shënime",
      note_1:
        "Për shuma më të mëdha se 1000 Euro (ose ekuivalente në monedha të tjera) ju lutem kontaktoni me Departamentin e Thesarit për të marrë kurs preferencial.",
      note_2:
        "Kursi zyrtar i këmbimit është subjekt i ndryshimeve që reflektojnë tregjet ndërkombëtare monetare.",
      note_3:
        "Për tarifa dhe komisione që paguhen nga llogaria juaj në bankë kursi i këmbimit që do aplikohet është kursi fiks i këmbimit i paracaktuar nga Banka e Shqipërisë).",
    },
    bonds: {
      title: "Llogaritës i Bonove të Thesarit",
      issuer: "Emetuesi",
      type: "Lloji i Bonos së Thesarit",
      isin: "ISIN",
      calcDate: "Data e veprimit",
      maturityDate: "Data e maturimit	",
      remainingDays: "Ditet e mbetura	",
      bidYield: "Yield i Blerjes	",
      askYield: "Yield i Shitjes",
      price: "Çmimi",
      interest: "Interesi",
      buySell: "Blerje/Shitje",
      calculatorBuySell: "Llogaritje për Blerje/Shitje",
      clientBuy: "Klienti ble",
      clientSell: "Klienti shet",
      nominalValueInLek: "Vlera Nominale ne LEK",
      calculate: "Llogarit",
      note_1:
        "Fibank ju ofron mundesine te investoni ne letra me vlere te Qeverise Shqiptare me maturime te ndryshme dhe me interesat me te mira ne treg.",
      note_2:
        "Fibank blen Bono Thesari nga klientet deri ne 1 dite para dates se maturimit.",
      note_3:
        "Fibank shet Bono Thesari me afate te ndryshme deri ne maturim dhe me cmime mjaft konkuruese krahasuar me tregun e Letrave me Vlere.",
      note_4: `Blerje/Shitje Bono Thesari nga Fibank date ${formatDate(
        new Date()
      )}.`,
      note_5:
        "Tek tabela meposhte keni kuotimet me te cilat Fibank ble dhe shet Bono Thesari cmimin e se ciles ju mund ta llogaritni vete.",
      note_6:
        "Interesi I perfituar nga bonot e thesarit eshte objekt i tatimit mbi te ardhurat.",
      notSupported: "Veprimi nuk ofrohet.",
    },
    obligations: {
      title: "Llogaritës i Obligacioneve të Thesarit",
      issuer: "Emetuesi",
      type: "Lloji i Bonos së Thesarit",
      isin: "ISIN",
      calcDate: "Data e veprimit",
      maturityDate: "Data e maturimit	",
      remainingDays: "Ditet e mbetura	",
      bidYield: "Yield i Blerjes	",
      askYield: "Yield i Shitjes",
      price: "Çmimi",
      interest: "Interesi",
      buySell: "Blerje/Shitje",
      calculatorBuySell: "Llogaritje për Blerje/Shitje",
      clientBuy: "Klienti ble",
      clientSell: "Klienti shet",
      nominalValueInLek: "Vlera Nominale ne LEK",
      calculate: "Llogarit",
      accrued: "",
      coupon: "Kuponi",
      bidPrice: "Çmimi i blerjes",
      askPrice: "Çmimi i shitjes",
      coupon6month: "Kuponi paguhet çdo 6 muaj",
      priceToPay: "Çmimi për t'u paguar",
      note_1:
        "Fibank ju ofron mundesine te investoni ne letra me vlere te Qeverise Shqiptare me maturime te ndryshme dhe me interesat me te mira ne treg.",
      note_2: `Blerje/Shitje Obligacione Thesari nga Fibank date ${formatDate(
        new Date()
      )}.`,
      note_3:
        "Fibank blen Obligacione Thesari nga klientet deri ne 1 dite para dates se maturimit.",
      note_4:
        "Fibank shet Obligacione Thesari me afate te ndryshme deri ne maturim dhe me cmime mjaft konkuruese krahasuar me tregun e Letrave me Vlere.",
      note_5:
        "Tek tabela meposhte keni kuotimet me te cilat Fibank ble dhe shet Obligacione Thesari cmimin e se ciles ju mund ta llogaritni vete.",
      note_6:
        "Nese deshironi te shisni nje T-Bond i cili nuk gjendet ne listen e meposhtme ju lutem paraqituni prane degeve tona.",
      note_7:
        "Interesi I perfituar nga bonot e thesarit eshte objekt i tatimit mbi te ardhurat.",
    },
    quickFAQ: {
      title: "Pyetjet e shpeshta",
      seeAll: "Shiko të gjitha",
    },
    creditApplication: {
      step: "Hapi",
      setOneTitle: "Të dhënat mbi kredinë",
    },
    errors: {
      required: "Fushë e detyrueshme",
      mustBeNumber: "Jepni një numër të vlefshëm",
      mustBeEmail: "Fusha duhet të jetë email",
      mustBePhoneNumber: "Fusha duhet të jetë numër telefoni",
      mustBeDate: "Fusha duhet të ketë formatin e mësipërm",
      mustBeInPast: "Duhet të jetë një datë në të shkuarën",
    },
    tools: {
      title: "Instrumenta",
      subtitle: "Banka pranë jush",
      contact: "Fibank në shërbimin tuaj",
      exchange: "Kursi i këmbimit",
      loan: "Apliko për kredi",
      creditCard: "Apliko për kartë krediti",
      deposit: "Llogaritësi i depozitave",
      bond: "Llogaritësi i bonove të thesarit",
      bill: "Llogaritësi i obligacioneve të thesarit",
    },
    footer: {
      bankAnywhere: "Banka në dorën tënde",
      mobileAndOnlineBanking: "",
      tools: {
        title: "Instrumenta",
      },
      products: {
        title: "Lidhje të shpejta",
      },
      others: {
        title: "Të tjera",
        personalData: "Të dhënat personale",
        cookies: "Menaxhimi i cookies",
        legalInformation: "Informacion ligjor",
        covid2019: "Protokolli I Verdhë i masave COVID-19",
      },
    },
    copyright: `© ${new Date().getFullYear()} Shkolla e Magjistraturës`,
    copyright_2: `Të drejtat e rezervuara`,
    buttonMenus: {
      login: "Kyçu",
      learnMore: "Më tepër",
      applyForLoan: "Apliko për kredi",
      loan: "Kredi",
      card: "Karta",
      info: "Informacion mbi produktin",
      apply: "Apliko",
      myFibank: "Dega Virtuale",
    },
    thankyouModal: {
      title: "Ju faleminderit",
      subtitle: "Të dhënat tuaja u dërguan dhe do të kontaktoheni së shpejti",
    },
    appBanner: {
      title: "Me aplikacionin Fibank Mobile, banka është në dorën tënde.",
      description:
        "* Aplikacioni Fibank Mobile i lehtë në përdorim, mundëson veprime bankare nga telefoni në kohë reale",
    },
    usefulLinks: {
      usefulLinks: "Informacione të vlefshme",
      depositGuarantee: "Garancia e depozitës",
      withdrawal: "Tërheqja e shumave",
    },
    jobVacancies: {
      closingDate: "Apliko deri më",
    },
    contact: {
      registrarOffice: "Sekretaria mësimore",
      labels: {
        address: "Adresa",
        phone: "Telefoni",
        email: "E-mail",
      },
      address: [
        'Godina "Poli i Drejtësisë"',
        "Rruga Ana Komnena",
        "Tiranë, Shqipëri",
      ].join("</br>"),
    },
    menu: {
      seeAll: "Lexo më tepër",
    },
    developedBy: "Zhvilluar nga Togo.al",
  },
};

export default sq;
